import {combineReducers} from 'redux';
import app from './app/reducer';
import user from './user/reducer';
import games from './games/reducer';
import modals from './modals/reducer';
import modals_action from './modals-action/reducer';
import modals_info from './modals-info/reducer';
import vip from './vip/reducer';
import vip20 from './vip20/reducer';
import wallet from './wallet/reducer';
import wheel from './wheel/reducer';
import invite from './invite/reducer';
import freecash from './freecash/reducer';
import tournaments from './tournaments/reducer';
import tasks from './tasks/reducer'; 
import lootbox from './lootbox/reducer';
import notifications from './notifications/reducer';
import popups from './popups/reducer';

import lucky_wheel from './lucky-wheel/reducer';
import modules from './modules/reducer';

export default combineReducers({
    app,
    user,
    games,
    modals,
    modals_action,
    modals_info,
    vip,
    vip20,
    wallet,
    wheel,
    invite,
    freecash,
    tournaments,
    tasks,
    lootbox,
    notifications,
    popups,
    
    lucky_wheel,
    modules
});